export default class Flyout {
	constructor( toggleSelector, menuSelector ) {
		this.toggle = document.querySelector( toggleSelector ); // Select the toggle button
		this.menu = document.querySelector( menuSelector ); // Select the flyout menu
		this.closeIcon = this.menu.querySelector( '.masthead__flyout--close-icon' ); // Select the close icon
		this.menuOpenClass = 'flyout--open'; // Class added to open the menu
		this.bodyClass = 'flyout-open'; // Class added to the body when the menu is open

		if ( ! this.toggle || ! this.menu ) {
			return;
		}

		this.init();
	}

	init() {
		// Toggle menu on click of the button
		this.toggle.addEventListener( 'click', () => this.toggleMenu() );

		// Close menu on click of the close icon
		this.closeIcon?.addEventListener( 'click', ( event ) => {
			this.closeMenu();
			event.stopPropagation();
		} );

		// Close menu when clicking outside of it
		document.addEventListener( 'click', ( e ) => this.handleOutsideClick( e ) );

		// Close menu when pressing the Escape key
		document.addEventListener( 'keyup', ( e ) => {
			if ( e.key === 'Escape' ) {
				this.closeMenu();
			}
		} );
	}

	toggleMenu() {
		if ( this.menu.classList.contains( this.menuOpenClass ) ) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	openMenu() {
		this.menu.classList.add( this.menuOpenClass );
		document.body.classList.add( this.bodyClass );
	}

	closeMenu() {
		this.menu.classList.remove( this.menuOpenClass );
		document.body.classList.remove( this.bodyClass );
		console.log( 'close menu' );
	}

	handleOutsideClick( e ) {
		// Close the menu if clicking outside the menu or toggle button
		if ( ! this.menu.contains( e.target ) && ! this.toggle.contains( e.target ) ) {
			this.closeMenu();
		}
	}
}

// Initialize Flyout
const flyout = new Flyout( '.masthead__flyout-menu-actions', '.masthead__flyout-menu' );
